import { 
  GET_MANUFACTURER_FAILURE, 
  GET_MANUFACTURER_REQUEST, 
  GET_MANUFACTURER_SUCCESS 
} from "./manufacturerTypes";

const initialState = {
  loading: false,
  manufacturer: [],
  error: "",
};

const getManufacturerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUFACTURER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MANUFACTURER_SUCCESS:
      return {
        loading: false,
        manufacturer: action.payload,
        error: "",
      };
    case GET_MANUFACTURER_FAILURE:
      return {
        loading: false,
        manufacturer: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

export { getManufacturerReducer };